import { BffBrandType } from '@/types/generated';

import { cacheFn } from '@utils/cacheFn';
import { getGraphHeaders } from '@utils/getGraphHeaders';
import { logWarning } from '@utils/miscUtils';

export const getBffFacilitiesByAddress = cacheFn(
	async (
		brand: BffBrandType,
		address: string,
		url: string,
		fetchAllIfNoResults: boolean | undefined,
		appName: string,
		appVersion: string
	) => {
		try {
			if (!brand) {
				return null;
			}
			const { getGraphQLClient } = await import(
				/* webpackChunkName:"getGraphQLClient" */ '@src/lib/graphql/getGraphQLClient'
			);
			return await getGraphQLClient(url).bffFacilitiesByAddress(
				{
					brand,
					address,
					fetchAllIfNoResults,
				},
				getGraphHeaders(appName, appVersion)
			);
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : String(err);
			logWarning(`Could not find any facilities data for: ${brand} for query: ${address}. ${errorMessage}`);
			return undefined;
		}
	}
);
